/* eslint-disable eqeqeq */
import { RaKeys, getRaStore, setRaStore } from './utils/common';

// Using Caching the response data to avoid making redundant requests to the server
export const cachedDatas = new Map();

const NONE_DATA = {
    data: [{ id: 0 }],
    total: 1
};

export function setCachedData (resource, data) {
    let storeKey = `${resource}.${RaKeys.isSearch}`;
    let isSearch = getRaStore(storeKey);
    if (isSearch == null) return;
    setRaStore(storeKey, false);
    setRaStore(`${resource}.${RaKeys.isCompleteSearch}`, true);
    if (data.total == 0) {
        data = NONE_DATA;
    }
    cachedDatas.set(resource, data);
}

export function getCachedData (resource) {
    let cachedData = cachedDatas.get(resource);
    if (cachedData) return cachedData;
    return NONE_DATA;
}